import {MonitoringServiceType} from "@/lib/types/checks.ts";
import {Snippets} from "@/lib/types/website.ts";
import {MultiSnippetBlock} from "@/pages/checks/components/form/snippets/MultiSnippet.tsx";
import {RUMSnippet} from "@/pages/checks/components/form/snippets/RUMSnippet.tsx";

export const CheckSnippetTitle: Partial<Record<MonitoringServiceType, string>> = {
  [MonitoringServiceType.RUM2]: "RUM Code For Your Site",
  [MonitoringServiceType.WEBHOOK]: "Webhook URL For Your Check",
  [MonitoringServiceType.HEARTBEAT]: "Heartbeat URL For Your Check",
};

export interface CheckSnippetProps {
  serviceType: MonitoringServiceType;
  snippets: Snippets;
  uuid: string;
  externalDomains?: string;
  isAjaxDisabled?: boolean;
  onModal?: boolean;
}

export const CheckSnippet = ({serviceType, snippets, ...props}: CheckSnippetProps) => {
  const title = CheckSnippetTitle[serviceType] || "";

  return (
    <>
      {serviceType === MonitoringServiceType.RUM2 && (
        <RUMSnippet title={title} snippet={snippets.rum2_snippet} {...props} />
      )}
      {serviceType === MonitoringServiceType.WEBHOOK && (
        <MultiSnippetBlock title={title} snippet={snippets.webhook_snippet} {...props} />
      )}
      {serviceType === MonitoringServiceType.HEARTBEAT && (
        <MultiSnippetBlock title={title} snippet={snippets.heartbeat_snippet} {...props} />
      )}
    </>
  );
};
